/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import Blockv from './managers/blockv';

Blockv.init().then(() => {
  ReactDOM.render(<App />, document.getElementById('root'));
});
